import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useViewport } from '@chilecompra/react-kit'
import { Button, Dialog, Toast, Typography } from '@chilecompra/react-kit/components'
import { inIframe } from '@chilecompra/react-kit/utils'

import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'

import { Container, DialogButtons, DialogContent, DialogMessage } from './BasicSellerInformationSection.styles'

/**
 * The EMT information modal component.
 */
const EMTModal = ({ onClose, isOpen, EMTClassificationDetail }) => {
  const {
    size: { isTiny }
  } = useViewport()

  const isInIframe = useMemo(() => {
    return inIframe()
  }, [])

  const handleOpenModalCallback = () => {
    if (isInIframe) {
      window.parent.postMessage(
        {
          action: 'scrollTo',
          value: {
            x: 0,
            y: 0
          }
        },
        REACT_APP_MERCADO_PUBLICO_BASE_URL
      )
    }
  }

  return (
    <Dialog
      disableBackdropClick
      maxWidth="750px"
      onClose={onClose}
      onOpen={handleOpenModalCallback}
      open={isOpen}
      padding="8px"
      verticalAlign="top"
    >
      <DialogContent padding="32px">
        <DialogMessage>
          <Typography fontWeight="bold" variant="h4">
            ¿Qué son las empresas de menor tamaño? (EMT)
          </Typography>

          <Container>
            <Typography variant="body2">
              Las empresas de menor tamaño se clasifican según sus ingresos anuales por ventas y servicios y otras
              actividades del giro:
            </Typography>

            <Typography variant="body2">
              (i) microempresas (no superan las 2.400 UF en ingresos el último año calendario);
            </Typography>

            <Typography variant="body2">
              (ii) pequeña empresa (más de 2.400 y no más de 25.000 UF en ingresos el último año calendario);
            </Typography>

            <Typography variant="body2">
              (iii) mediana empresa (más de 25.000 y no más de 100.000 UF en ingresos el último año calendario).
            </Typography>
          </Container>

          <Typography variant="body2">Fuente: Articulo 1 y 2. Ley N°20.416</Typography>

          <Typography variant="body2">
            Además, la clasificación EMT puede diferir de la establecida por Servicio de impuestos Internos si se
            detecta que tu empresa pertenece a un grupo empresarial en el que la sociedad controladora no sea una
            empresa de menor tamaño.
          </Typography>

          <Toast severity="info" textDirection="vertical" title="¿Por qué mi empresa no clasifica como EMT?">
            {EMTClassificationDetail?.isForced &&
            EMTClassificationDetail.forcedReason === 'CONTROLADO POR SOCIEDAD NO EMT'
              ? 'Aunque tu empresa cumple con los ingresos definidos por el SII y figura como EMT, en Mercado Público no puede clasificarse como tal porque está controlada por una sociedad que no es EMT. Según el artículo 47 de la Ley N°19.886, en este caso se pierde la clasificación como Empresa de Menor Tamaño.'
              : 'Su empresa no puede clasificarse como EMT según los datos del Servicio de Impuestos Internos.'}
          </Toast>
        </DialogMessage>

        <DialogButtons alignItems="center" direction="column" justifyContent="center">
          <Button onClick={onClose} width={!isTiny && '180px'}>
            Cerrar
          </Button>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}

EMTModal.propTypes = {
  EMTClassificationDetail: PropTypes.shape({
    isForced: PropTypes.bool,
    forcedReason: PropTypes.string
  }),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}

export default EMTModal
